import { Box } from "@mui/material";
import { FC } from "react";
import { NOVA_COLORS } from "./character";

type NovaFaceProps = {
  size?: number;
  speaking?: boolean;
};

export const NovaFace: FC<NovaFaceProps> = ({ size = 52, speaking = false }) => (
  <Box
    component="svg"
    viewBox="0 0 80 80"
    width={size}
    height={size}
    aria-hidden
    sx={{
      display: "block",
      transform: speaking ? "scale(1.04)" : "scale(1)",
      transition: "transform 160ms ease",
    }}
  >
    <defs>
      <clipPath id="nova-face-clip">
        <circle cx="40" cy="40" r="38" />
      </clipPath>
      <radialGradient id="nova-fur" cx="35%" cy="28%" r="75%">
        <stop offset="0%" stopColor={NOVA_COLORS.mintWash} />
        <stop offset="55%" stopColor={NOVA_COLORS.mint} />
        <stop offset="100%" stopColor={NOVA_COLORS.brand} />
      </radialGradient>
    </defs>
    <circle cx="40" cy="40" r="38" fill="url(#nova-fur)" />
    <g clipPath="url(#nova-face-clip)">
      <ellipse cx="22" cy="28" rx="12" ry="14" fill={NOVA_COLORS.brand} />
      <ellipse cx="58" cy="28" rx="12" ry="14" fill={NOVA_COLORS.brand} />
      <ellipse cx="22" cy="29" rx="7" ry="8" fill={NOVA_COLORS.mintLight} />
      <ellipse cx="58" cy="29" rx="7" ry="8" fill={NOVA_COLORS.mintLight} />
      <ellipse cx="40" cy="48" rx="26" ry="24" fill={NOVA_COLORS.mintWash} />
      <path
        d="M40 18 L43.2 26.4 L52 27.2 L45.4 32.8 L47.2 41.2 L40 36.6 L32.8 41.2 L34.6 32.8 L28 27.2 L36.8 26.4 Z"
        fill="#FFE27A"
      />
      <ellipse cx="28" cy="44" rx="6.5" ry="7.5" fill="#1B2433" />
      <ellipse cx="52" cy="44" rx="6.5" ry="7.5" fill="#1B2433" />
      <ellipse cx="26.2" cy="41.8" rx="2.2" ry="2.6" fill="#fff" />
      <ellipse cx="50.2" cy="41.8" rx="2.2" ry="2.6" fill="#fff" />
      <path
        d="M20 40 Q24 36 28 39"
        fill="none"
        stroke={NOVA_COLORS.brandDeep}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M52 39 Q56 36 60 40"
        fill="none"
        stroke={NOVA_COLORS.brandDeep}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <ellipse cx="27" cy="54" rx="5" ry="3" fill="#F4A4C4" opacity="0.7" />
      <ellipse cx="53" cy="54" rx="5" ry="3" fill="#F4A4C4" opacity="0.7" />
      <ellipse cx="40" cy="56" rx="4.2" ry="3.2" fill={NOVA_COLORS.brandDark} />
      <path
        d="M36 61 Q40 65 44 61"
        fill="none"
        stroke={NOVA_COLORS.brandDark}
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </g>
    <circle
      cx="40"
      cy="40"
      r="38"
      fill="none"
      stroke="rgba(255,255,255,0.45)"
      strokeWidth="2"
    />
  </Box>
);
